import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '../store/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import('../views/Signup.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/verify',
    name: 'Verify',
    component: () => import('../views/Verify.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('../views/ForgotPassword.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/team/create',
    name: 'CreateTeam',
    component: () => import('../views/TeamForm.vue'),
    meta: { requiresAuth: true, role: 'MANAGER' }
  },
  {
    path: '/team/:id/edit',
    name: 'EditTeam',
    component: () => import('../views/TeamForm.vue'),
    meta: { requiresAuth: true, role: 'MANAGER' }
  },
  {
    path: '/targets',
    name: 'Targets',
    component: () => import('../views/Targets.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/teams',
    name: 'AdminTeams',
    component: () => import('../views/AdminTeams.vue'),
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  {
    path: '/admin/targets',
    name: 'AdminTargets',
    component: () => import('../views/AdminTargets.vue'),
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  {
    path: '/admin/config',
    name: 'AdminConfig',
    component: () => import('../views/AdminConfig.vue'),
    meta: { requiresAuth: true, role: 'ADMIN' }
  },
  {
    path: '/rules',
    name: 'Rules',
    component: () => import('../views/Rules.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/help',
    name: 'Help',
    component: () => import('../views/Help.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard
router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiredRole = to.meta.role as string | undefined

  if (requiresAuth && !authStore.isAuthenticated) {
    // Not authenticated, redirect to login
    return next({ name: 'Login', query: { redirect: to.fullPath } })
  } else if (requiresAuth && requiredRole && authStore.user?.role !== requiredRole) {
    // Wrong role, redirect to dashboard
    return next({ name: 'Dashboard' })
  } else if (!requiresAuth && authStore.isAuthenticated && (to.name === 'Login' || to.name === 'Signup' || to.name === 'ForgotPassword')) {
    // Already authenticated, redirect to dashboard
    return next({ name: 'Dashboard' })
  } else {
    return next()
  }
})

export default router
